import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function ValuesSection() {
  const {
    t
  } = useLanguage();
  const values = [{
    title: t('values.experience.title'),
    description: t('values.experience.desc'),
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-257">
          <circle cx="12" cy="12" r="10" data-id="element-258" />
          <path d="M12 6v6l4 2" strokeLinecap="round" data-id="element-259" />
        </svg>
  }, {
    title: t('values.quality.title'),
    description: t('values.quality.desc'),
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-260">
          <path d="M12 2l2.5 7.5H22l-6 4.5 2.5 7.5L12 17l-6.5 4.5L8 14 2 9.5h7.5z" data-id="element-261" />
        </svg>
  }, {
    title: t('values.guarantee.title'),
    description: t('values.guarantee.desc'),
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-262">
          <path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6z" data-id="element-263" />
          <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" data-id="element-264" />
        </svg>
  }, {
    title: t('values.service.title'),
    description: t('values.service.desc'),
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-265">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" data-id="element-266" />
          <circle cx="12" cy="7" r="4" data-id="element-267" />
        </svg>
  }];
  return <section className="py-28 lg:py-36 px-6 bg-white" data-id="element-268">
      <div className="max-w-7xl mx-auto" data-id="element-269">
        <div className="text-center mb-20" data-id="element-270">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-4 tracking-tight font-light" data-id="element-271">
            {t('values.title')}
          </h2>
          <div className="w-20 h-[1px] bg-[#B8956C] mx-auto mt-8" data-id="element-272"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10" data-id="element-273">
          {values.map((value, index) => <div key={index} className="group" data-id="element-274">
              <div className="bg-[#FAFAF8] border border-[#1A1A1A]/5 p-8 h-full transition-all duration-500 hover:border-[#B8956C]/30 hover:shadow-sm" data-id="element-275">
                {/* Icon */}
                <div className="mb-6 text-[#B8956C]" data-id="element-276">{value.icon}</div>

                {/* Title */}
                <h3 className="font-serif text-xl mb-4 tracking-wide font-medium" data-id="element-277">
                  {value.title}
                </h3>

                {/* Divider */}
                <div className="w-12 h-[1px] bg-[#B8956C]/20 mb-4" data-id="element-278"></div>

                {/* Description */}
                <p className="text-[#1A1A1A]/60 font-light text-sm leading-relaxed" data-id="element-279">
                  {value.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}